module.exports = __webpack_public_path__ + "img/moon.b10acad2.svg";